import type { DeliveryAddress, LookupAddress } from "~/types";

export function toDeliveryAddress(
  address?: LookupAddress,
  apartment?: string,
): DeliveryAddress | null {
  if (!address) {
    return null;
  }

  // Explicit copy because mutation doesn't like
  // excess fields
  return {
    apartment,
    streetAddress: address.streetAddress,
    locality: address.locality,
    region: address.region,
    postcode: address.postcode,
    country: address.country,
    coords: address.coords && {
      lat: address.coords.lat,
      lng: address.coords.lng,
    },
  };
}
